import { render, staticRenderFns } from "./Gakuchika.vue?vue&type=template&id=6af333fa&scoped=true&"
import script from "./Gakuchika.vue?vue&type=script&lang=js&"
export * from "./Gakuchika.vue?vue&type=script&lang=js&"
import style0 from "./Gakuchika.vue?vue&type=style&index=0&id=6af333fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af333fa",
  null
  
)

export default component.exports